module.exports = __webpack_public_path__ + "static/media/sol.1b02d22f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sol.png
// module id = 114
// module chunks = 0